import { BaseService } from 'core/services';
import ItemCategoryRouteService from './ItemCategoryRouteService';

class ItemCategoryService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ItemCategoryRouteService());
    }
}

export default ItemCategoryService;
